import React from 'react';
import BasicComponent from 'core/basic-component.jsx';


class FormFieldFormElementProto extends BasicComponent {

    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };

        this._bind('onChange');

    }

    render() {
        return <div>Not implemented</div>;
    }

}

// FormFieldFormElementProto.propTypes = props;
// FormFieldFormElementProto.defaultProps = defaultProps;

module.exports = FormFieldFormElementProto;
